var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('Groups')))]),_c('p',[_vm._v("Bearbeite Gruppen oder erstelle eine Neue:")]),_c('UserGroups')],1)}
var staticRenderFns = []

export { render, staticRenderFns }